/* Two native, filtered Shopify streams keep stock ahead of sold-out items
   across pagination. Each request loads only the cards needed for this page. */
(() => {
  async function order(grid) {
    if (grid.dataset.orderStarted) return;
    grid.dataset.orderStarted = 'true';
    const size = Number(grid.dataset.pageSize);
    const start = (Number(grid.dataset.page) - 1) * size;
    const params = new URLSearchParams(location.search);
    params.delete('section_id');
    params.delete('view');
    params.set('sort_by', params.get('sort_by') || 'best-selling');
    const requestURL = (page) => {
      const url = new URL(location.pathname, location.origin);
      url.search = params.toString();
      url.searchParams.set('page', String(page));
      return url;
    };
    try {
      const stocked = [], other = [];
      const remaining = Math.max(0, Math.min(size, Number(grid.dataset.total) - start));
      // Read a small inventory index until this page is filled. Later pages continue
      // scanning so stock remains first across the entire collection, not just one page.
      for (let page = 1, pages = 1; page <= pages; page++) {
        const url = requestURL(page);
        url.searchParams.set('view', 'rl-stock-index');
        const response = await fetch(url);
        if (!response.ok) throw new Error('Inventory index unavailable');
        const index = await response.json();
        pages = index.pages;
        index.items.forEach((item, i) => {
          item.position = (page - 1) * 250 + i;
          (item.stock ? stocked : other).push(item);
        });
        if (stocked.length >= start + remaining) break;
      }
      const selected = [...stocked, ...other].slice(start, start + remaining);
      if (selected.length !== remaining) throw new Error('Catalogue changed');
      const pages = [...new Set(selected.map(item => Math.floor(item.position / size) + 1))];
      const cards = new Map();
      await Promise.all(pages.map(async page => {
        const url = requestURL(page);
        url.searchParams.set('section_id', grid.dataset.id);
        const response = await fetch(url);
        if (!response.ok) throw new Error('Collection unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        doc.querySelectorAll('#product-grid > [data-product-id]').forEach(card => cards.set(card.dataset.productId, card));
      }));
      const ordered = selected.map(item => cards.get(item.id));
      if (ordered.some(card => !card)) throw new Error('Catalogue changed');
      if (!grid.isConnected) return;
      grid.querySelectorAll(':scope > .columns:not(.pagination)').forEach(card => card.remove());
      const pagination = grid.querySelector('.pagination');
      ordered.forEach(card => grid.insertBefore(card, pagination));
      grid.dataset.orderReady = 'true';
      grid.removeAttribute('aria-busy');
    } catch (_) {
      // Never flash a misleading sold-out first row when an ordering request fails.
      grid.dataset.orderFailed = 'true';
      const message = document.createElement('p');
      message.className = 'small-12 columns rl-order-error';
      message.textContent = document.documentElement.lang === 'fr'
        ? 'Impossible de charger les produits. Veuillez actualiser la page.'
        : 'Products could not load. Please refresh the page.';
      grid.prepend(message);
      grid.removeAttribute('aria-busy');
    }
  }
  const init = () => document.querySelectorAll('[data-stock-order]').forEach(order);
  const start = () => {
    init();
    const container = document.getElementById('ProductGridContainer');
    if (container) new MutationObserver(init).observe(container, { childList: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
